import { render, staticRenderFns } from "./settingPortal.vue?vue&type=template&id=580e15b0&scoped=true&"
import script from "./settingPortal.vue?vue&type=script&lang=js&"
export * from "./settingPortal.vue?vue&type=script&lang=js&"
import style0 from "./settingPortal.vue?vue&type=style&index=0&id=580e15b0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "580e15b0",
  null
  
)

export default component.exports